import { render, staticRenderFns } from "./LotteryConfig.vue?vue&type=template&id=5fc3d6b4"
import script from "./LotteryConfig.vue?vue&type=script&lang=js"
export * from "./LotteryConfig.vue?vue&type=script&lang=js"
import style0 from "./LotteryConfig.vue?vue&type=style&index=0&id=5fc3d6b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8bd846dc4b65c5b8a85fd68976b17e9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports